import { GetterTree } from "vuex";
import { AreaState, GroupWithPermissions, Tenant } from "./types";
import { RootState } from "@/store/types";

export const areaGetters: GetterTree<AreaState, RootState> = {
	/**
	 * @deprecated This getter is deprecated. Use the AreaTreeSelect instead as it supports permission filtering.
	 */
	getAreaList: state => state.AreaList as GroupWithPermissions[],

	/**
	 * @deprecated This getter is deprecated. Use fetchAreaDictionary and getAreaTitle instead.
	 */
	getAreaTitleById: state => {
		return groupId => {
			if (state.AreaList.length == 0) return;
			const area = state.AreaList.find((area: GroupWithPermissions) => area.groupID == groupId);
			if (area) return area.title;
		};
	},
	getAreaTitle: state => (groupId: number) => {
		return state.areaDictionary[groupId];
	}
};
